import { render, staticRenderFns } from "./kselect.vue?vue&type=template&id=2e24c263&scoped=true"
import script from "./kselect.vue?vue&type=script&lang=js"
export * from "./kselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24c263",
  null
  
)

export default component.exports